export default __webpack_public_path__ + "static/media/Potent Soursap.6490bacc.jpg";